import script from "./DocumentRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocumentRow.vue?vue&type=script&setup=true&lang=ts"

import "./DocumentRow.vue?vue&type=style&index=0&id=7931967e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7931967e"]])

export default __exports__